import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_HealthReassessment = ({ itemsRef, showErrorFor }) => {


    return (<form id='GENERAL_HealthReassessment' className='file-pdf-document'>
        <div className='file-template'>

            <h3>
                Health &amp; Behavior Reassessment
            </h3>
            <table>
                <tr>
                    <td className='w-250'>
                        <span className='eleHeader'>Date of Birth:</span>
                        <input type='date' id="txtDOB" name="txtDOB" className='add-only' />
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Client's Age:</span>
                        <input type='text' id="txtAge" name="txtAge" className='add-only' />
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Place of Service Assessments:</span>
                        <select id="ddlPlaceOfService" name="ddlPlaceOfService" className='add-only'>
                            <option value=""></option>
                            <option value="Office">Office</option>
                            <option value="Court">Court</option>
                            <option value="Home">Home</option>
                        </select>
                    </td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>Special Problems</span>
                <span className='small'>
                    Notate any special problems or issues the client is having.</span>
                <textarea id="txtSpecialProblems" name="txtSpecialProblems" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Any current thoughts of suicide?</span>

                <select id="ddlSuicidalThoughts" name="ddlSuicidalThoughts" className='add-only'>
                    <option value=""></option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Sometimes">Sometimes</option>
                    <option value="Unknown">Unknown</option>
                </select>
            </p>
            <p className='w-750'>
                If Yes, please describe:
                <textarea id="txtSuicideThoughts" name="txtSuicideThoughts" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>Any current thoughts of self-mutilation?</span>
                <select id="ddlSelfMutilationThoughts" name="ddlSelfMutilationThoughts" className='add-only'>
                    <option value=""></option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Sometimes">Sometimes</option>
                    <option value="Unknown">Unknown</option>
                </select>
            </p>
            <p className='w-750'>
                If Yes, please describe:
                <textarea id="txtSelfMutilation" name="txtSelfMutilation" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>
                    Any safety contacts within the last 30 days?</span>
                <select id="ddlSafetyContracts" name="ddlSafetyContracts" className='add-only'>
                    <option value=""></option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Sometimes">Sometimes</option>
                    <option value="Unknown">Unknown</option>
                </select>
            </p>
            <p className='w-750'>If Yes, please describe:
                <textarea id="txtSafetyContacts" name="txtSafetyContacts" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>
                    Any acts of aggression to others or property within the last 30 days?</span>
                <select id="ddlActsOfAggression" name="ddlActsOfAggression" className='add-only'>
                    <option value=""></option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Sometimes">Sometimes</option>
                    <option value="Unknown">Unknown</option>
                </select>
            </p>
            <p className='w-750'>If Yes, please describe:
                <textarea id="txtAggression" name="txtAggression" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>
                    Any current thoughts of harming others?</span>
                <select id="ddlHarmfulThoughts" name="ddlHarmfulThoughts" className='add-only'>
                    <option value=""></option>
                    <option value="Content">Content</option>
                    <option value="Avoids gaze">Avoids gaze</option>
                    <option value="Flat">Flat</option>
                    <option value="Hostile">Hostile</option>
                    <option value="Sad">Sad</option>
                    <option value="Worried">Worried</option>
                    <option value="Other">Other</option>
                </select>
            </p>
            <p className='w-750'>If Yes, please describe:
                <textarea id="txtHarmfulThoughts" name="txtHarmfulThoughts" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>
                    Any episodes of seclusion or restraint within the last 30 days?</span>
                <select id="ddlSeclusion" name="ddlSeclusion" className='add-only'>
                    <option value=""></option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Sometimes">Sometimes</option>
                    <option value="Unknown">Unknown</option>
                </select>
            </p>
            <p className='w-750'>If Yes, please describe:
                <textarea id="txtSeclusion" name="txtSeclusion" className='add-only'></textarea>
            </p>
            <h3>
                Nutritional Status</h3>
            <p className='w-750'>
                <span className='eleHeader'>List Food Allergies/Sensitivities:</span>
                <textarea id="txtFoodAllergies" name="txtFoodAllergies" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <input type="checkbox" name="txtHistoryBinging" className='add-only' value="Client has History of Binge Eating/Induced Vomiting" /> Client has History of Binge Eating/Induced Vomiting
            </p>
            <table>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Number of meals eaten per day:</span>
                        <input type='text' id="txtMealsPerDay" name="txtMealsPerDay" className='add-only' />
                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Number of snacks per day:</span>
                        <input type='text' id="txtSnacksPerDay" name="txtSnacksPerDay" className='add-only' />
                    </td>
                </tr>
                <tr>

                    <td className='w-375'>
                        <span className='eleHeader'>Number of fast food meals per week:</span>
                        <input type='text' id="txtFastFood" name="txtFastFood" className='add-only' />
                    </td>
                    <td className='w-375'>&nbsp;</td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>List appetite changes:</span>
                <textarea id="txtAppetiteChanges" name="txtAppetiteChanges" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>List significant weight losses/gains:</span>
                <span className='small'>Describe pounds and time period.</span>
                <textarea id="txtWeightChanges" name="txtWeightChanges" className='add-only'></textarea></p>
            <table>
                <tr>
                    <td className='w-375'>
                        <input name="cbEatingDisorder" className='add-only' value="Does client have an eating disorder?" type="checkbox" /> Does client have an eating disorder?
                    </td>
                    <td className='w-375'>
                        <input name="cbPrescribedDiet" className='add-only' value="Is client on a medically prescribed diet?" type="checkbox" /> Is client on a medically prescribed diet?
                    </td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>If on prescribed diet, list details:</span>
                <textarea id="txtDiet" name="txtDiet" className='add-only'></textarea></p>
            <table>
                <tr>
                    <td className='w-375'>
                        <input name="cbWeightLossGainDesire" className='add-only' value="Does client desire to lose or gain weight?" type="checkbox" /> Does client desire to lose or gain weight?
                    </td>
                    <td className='w-375'>
                        Is client's appearance normal or abnormal?
                        <select id="ddlAppearance" name="ddlAppearance" className='add-only'>
                            <option value="*Choose*">*Choose*</option>
                            <option value="Normal">Normal</option>
                            <option value="Abnormal">Abnormal</option>
                        </select>
                    </td>
                </tr>
            </table>
            <h3>
                Sexual Behavior</h3>
            <p className='w-750'>
                <input name="cbIsSexuallyActive" className='add-only' value="Is or has client been sexually active?" type="checkbox" /> Is or has client been sexually active?
            </p>
            <table>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Date of last menstration:</span>
                        <input type='date' id="txtLastMenstration" name="txtLastMenstration" className='add-only' />
                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Date of last pelvic exam:</span>
                        <input type='date' id="txtLastPelvicExam" name="txtLastPelvicExam" className='add-only' />
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'>List date(s) of any miscarriage(s):</span>
                        <textarea typeof='text' id="txtMiscarriage" name="txtMiscarriage" className='add-only'></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'>List date(s) of any abortion(s):</span>
                        <textarea typeof='text' id="txtAbortion" name="txtAbortion" className='add-only'></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <input name="cbIsLactating" value="Is client lactating?" type="checkbox" className='add-only' /> Is client lactating?
                    </td>
                </tr>
            </table>
            <table border={0}>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Problems with Pregnancy" /> Problems with Pregnancy
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Penile Discharge" /> Penile Discharge
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Pelvic Pain" /> Pelvic Pain
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="UTI" /> UTI
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Gynecomastia" /> Gynecomastia
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Dysuria" /> Dysuria
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Nipple Discharge" /> Nipple Discharge
                    </td>
                    <td className='w-500'>
                        <input type="checkbox" name="chkSexualProblems" className='add-only' value="Prostate Problems" /> Prostate Problems
                    </td>
                </tr>
            </table>

            <h3>
                Sleep Patterns</h3>
            <p className='w-750'>
                <span className='eleHeader'>List any sleep problems the client has experienced:</span>
                <textarea id="txtSleepProblems" name="txtSleepProblems" className='add-only'></textarea></p>
            <h3>
                Allergies</h3>
            <p className='w-750'>
                <span className='eleHeader'>List drug allergies:</span>
                <textarea id="txtDrugAllergies" name="txtDrugAllergies" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>List environmental allergies:</span>
                <textarea id="txtEnvironmentalAllergies" name="txtEnvironmentalAllergies" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>List contact allergies:</span>
                <textarea id="txtContactAllergies" name="txtContactAllergies" className='add-only'></textarea></p>
            <p className='w-750'>
                <input type="checkbox" name="cbEpiPen" className='add-only' value="Client uses an epi pen." /> Client uses an epi pen.</p>

            <h3>Hygiene</h3>
            <p className='w-750'>
                <span className='eleHeader'>Describe client's hygiene:</span>
                <textarea id="txtDescribeHygiene" name="txtDescribeHygiene" className='add-only'></textarea></p>
            <p className='w-750'>
                <input type="checkbox" name="cbEncopresisProblems" className='add-only' value="Client has problems with encopresis or enuresis." /> Client has problems with encopresis or enuresis.</p>
            <p className='w-750'>
                <span className='eleHeader'>If so, how often?</span>
                <textarea id="txtEncopresisHowOften" name="txtEncopresisHowOften" className='add-only'></textarea></p>
            <p className='w-750'>
                <span className='eleHeader'>Describe client's appearance:</span>
                <textarea id="txtClientAppearance" name="txtClientAppearance" className='add-only'></textarea></p>

            <h3>
                Vitals</h3>
            <table>
                <tr>
                    <td className='w-250'>
                        <span className='eleHeader'>Height:</span>
                        <input type='text' id="txtHeight" name="txtHeight" className='add-only' /> (inches)
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Weight:</span>
                        <input type='text' id="txtWeight" name="txtWeight" className='add-only' /> (pounds)
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>BMI:</span>
                        <input type='text' id="txtBMI" name="txtBMI" className='add-only' />
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <span className='eleHeader'>Birth Weight:</span>
                        <input type='text' id="txtBirthWeight" name="txtBirthWeight" className='add-only' /><br />
                        <input type="checkbox" name="cbPrematurelyBorn" className='add-only' value="Prematurely born?" />
                        Prematurely born?
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Temperature:</span>
                        <input type='text' id="txtTemperature" name="txtTemperature" className='add-only' />
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Method used:</span>
                        <input type='text' id="txtMethodUsed" name="txtMethodUsed" className='add-only' />
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <span className='eleHeader'>Pulse/min.:</span>
                        <input type='text' id="txtPulse" name="txtPulse" className='add-only' />
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Respirations/min.:</span>
                        <input type='text' id="txtRespirations" name="txtRespirations" className='add-only' />
                    </td>
                    <td className='w-250'>
                        <span className='eleHeader'>Blood pressure (sitting):</span>
                        <input type='text' id="txtBP" name="txtBP" className='add-only' />
                    </td>
                </tr>
            </table>
            <h3>
                Vision Screening</h3>
            <table>
                <tr>
                    <td className='w-187'>
                        <span className='eleHeader'>Without Correction:</span>
                        <input type='text' id="txtVisionWithoutCorrection" name="txtVisionWithoutCorrection" className='add-only' />
                    </td>
                    <td className='w-187'>
                        <span className='eleHeader'>Right Eye:</span>
                        <input type='text' id="txtRightEye" name="txtRightEye" className='add-only' />
                    </td>
                    <td className='w-187'>
                        <span className='eleHeader'>Left Eye:</span>
                        <input type='text' id="txtLeftEye" name="txtLeftEye" className='add-only' />
                    </td>
                    <td className='w-187'>
                        <span className='eleHeader'>Both Eyes:</span>
                        <input type='text' id="txtBothEyes" name="txtBothEyes" className='add-only' />
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <span className='eleHeader'>With Correction:</span>
                        <input type='text' id="txtVisionWithCorrection" name="txtVisionWithCorrection" className='add-only' />
                    </td>
                    <td className='w-187'>
                        <span className='eleHeader'>Right Eye:</span>
                        <input type='text' id="txtRightEyeWith" name="txtRightEyeWith" className='add-only' />
                    </td>
                    <td className='w-187'>
                        <span className='eleHeader'>Left Eye:</span>
                        <input type='text' id="txtLeftEyeWith" name="txtLeftEyeWith" className='add-only' />
                    </td>
                    <td className='w-187'>
                        <span className='eleHeader'>Both Eyes:</span>
                        <input type='text' id="txtBothEyesWith" name="txtBothEyesWith" className='add-only' />
                    </td>
                </tr>
            </table>
            <p className='w-750'>
                <input type="checkbox" name="cbWearsGlasses" className='add-only' value="Client wears glasses." /> Client wears glasses<br />
                <input type="checkbox" name="cbWearsContacts" className='add-only' value="Client wears contacts." /> Client wears contacts.</p>

            <h3>
                Medications</h3>
            <p className='w-750'>
                <span className='eleHeader'>List Current Medications:</span>
                <span className='small'>
                    Include: 1) Name of medicine, 2) Prescribing doctor, 3) Dosage, 4) Prescription
                    date.</span>
                <textarea id="txtMedications" name="txtMedications" className='add-only'></textarea></p>
            <h3>
                Medication Self-Administration Competency Assessment</h3>
            <p className='w-750'>
                <input type="checkbox" name="cbStateMedNames" className='add-only' value="Client is able to state the name(s) of their medication(s)." /> Client is able to state the name(s) of their medication(s).<br />
                <input type="checkbox" name="cbStateMedDoses" className='add-only' value="Client is able to state the dose(s) of their medication(s)." /> Client is able to state the dose(s) of their medication(s).<br />
                <input type="checkbox" name="cbRecognizeMeds" className='add-only' value="Client recognizes their medication(s) upon visual inspection." /> Client recognizes their medication(s) upon visual inspection.<br />
                <input type="checkbox" name="cbMedEffectsExplained" className='add-only' value="The medication(s) side effects and risks have been explained to client." /> The medication(s) side effects and risks have been explained to client.<br />
                <input type="checkbox" name="cbSelfAdminDeficits" className='add-only' value="Does client have any deficits that limit their ability to self-administer medication(s) under supervision." /> Does client have any deficits that limit their ability to self-administer medication(s) under supervision.<br />
                <input type="checkbox" name="txtSelfAdminCompetent" className='add-only' value="Client is competent to self-administer medication with supervision." /> Client is competent to self-administer medication with supervision.<br />
            </p>

        </div>
    </form >
    )
}